import React, { Component } from "react";
import { connect } from "react-redux";
import EditActions from "../schema/misc/EditActions";
import CenteredPaper from "../layouts/CenteredPaper";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { MoneyInput } from "../atoms/MoneyInput";
import { IrqTitle } from "../molecules/IrqTitle";
import ILearn from "../molecules/ILearn";

class REFINANCEIRQExistingBalanceView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          <div className="money-input-wrapper">
            <MoneyInput
              name="existingLoanBalance"
              error={!!this.props.errors.existingLoanBalance}
              value={this.props.values.existingLoanBalance || ""}
              onChange={this.props.onFormEdit}
              onBlur={this.props.onBlur}
            />
          </div>
          <EditActions canSubmit={this.props.isValid} />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(REFINANCEIRQExistingBalanceView));
